import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const lMTubeApi = createApi({
  reducerPath: 'lMTubeApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['TubeLinks'],
  endpoints: builder => ({
    getTubeLinks: builder.query({
      query: (params) => ({
        url: `/links/tube/`,
        params,
      }),
      providesTags: ['TubeLinks']
    }),

    createTube: builder.mutation({
      query: body => ({
        url: '/links/tube/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['TubeLinks']
    }),

    markTube: builder.mutation({
      query: body => ({
        url: `/links/tube/mark/`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['TubeLinks']
    }),

    getTubeById: builder.query({
      query: id => ({
        url: `/links/tube/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'TubeLinks', id }]
    }),

    updateTubeById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/tube/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['TubeLinks']
    }),

    deleteTubeById: builder.mutation({
      query: id => ({
        url: `/links/tube/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, id) => [{ type: 'TubeLinks', id }]
    }),
    getTubeAggregateLinksByServiceId: builder.query({
      query: serviceId => {
        return `/links/tube/aggregate-by-campaign/${serviceId}/`
      },
      providesTags: ['TubeLinks']
    })
  })
})

export const {
  useGetTubeLinksQuery,
  useCreateTubeMutation,
  useMarkTubeMutation,
  useGetTubeByIdQuery,
  useUpdateTubeByIdMutation,
  useDeleteTubeByIdMutation,
  useGetTubeAggregateLinksByServiceIdQuery,
} = lMTubeApi
